import { createFunctional } from '@/components/utils/helpers'

let PageBody = createFunctional('page-body')

export { PageBody }
